module.exports = __webpack_public_path__ + "img/hipercard.61789dba.png";